import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  UsageContainer,
  ChartRow,
  Wrapper,
  SortingHeader,
} from "pages/Pace/Reports/ReportsStyled";
import MenuItem from "@mui/material/MenuItem";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CircleBtn } from "assets/css/globle";
import { useHookstate } from "@hookstate/core";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import _ from "lodash";
import { setAppDataReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import SelectArrow from "assets/svgIcons/SelectArrowIcon";
import "@progress/kendo-theme-default/dist/all.css";
import {
  Chart,
  ChartSeries,
  ChartTooltip,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartLegend,
  ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { ClickAwayListener } from "@mui/base";
import { featureKey } from "constant";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";

const Reports = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(moment(new Date()));
  const [endDate, setEndDate] = useState(moment(new Date()));
  const [timeIncrement, setTimeIncrement] = useState(2);
  const [RefreshChartHoleTime, setRefreshChartHoleTime] = useState(true);
  const [RefreshChartHolePace, setRefreshChartHolePace] = useState(true);
  const [RefreshChartAvgTime, setRefreshChartAvgTime] = useState(true);
  const [RefreshChartRounds, setRefreshChartRounds] = useState(true);
  const [RefreshChartAvgTee, setRefreshChartAvgTee] = useState(true);
  const [RefreshChartTeeRound, setRefreshChartTeeRound] = useState(true);
  const [startTimeHours, setStartTimeHours] = useState(7);
  const [startTimeState, setStartTimeState] = useState("07:00");
  const [endTimeState, setEndTimeState] = useState("16:30");
  const [startTimeMinutes, setStartTimeMinutes] = useState(0);
  const [endTimeHours, setEndTimeHours] = useState(16);
  const [endTimeMinutes, setEndTimeMinutes] = useState(30);
  const [yearLabel, setYearLabel] = useState("");
  const [monthLabel, setMonthLabel] = useState("");
  const [quaterLabel, setQuaterLabel] = useState("");
  const [courseList, setCourseList] = React.useState([]);
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [MtdState, setMtdState] = useState(false);
  const [QtdState, setQtdState] = useState(false);
  const [YTDState, setYTDState] = useState(false);
  const [ChartInfoState, setChartInfoState] = useState(null);
  const [courseIndex, setCourseIndex] = useState(0);
  const [errorHandler] = useState({
    startDateError: "",
    endDateError: "",
    otherError: "",
    totalDays: "",
  });
  const [ChartTimeInfoState, setChartTimeInfoState] = useState(null);
  const [ChartTitleValueState, setChartTitleValueState] = useState("");
  const [paceReportsSelectedCourse, setPaceReportsSelectedCourse] = useState(1);
  const [courseSelect, setCourseSelect] = useState();
  const {
    siteSettingsData,
    getPaceByHoleState,
    getRoundsByDayState,
    getRoundTimeOutData,
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
  } = useSelector((state) => state.commonReducers) || "";

  const [siteIdData, setsiteIdData] = useState(null);
  const [paceByDate, setPaceByDate] = useState([]);
  const [paceValues, setPaceValues] = useState([]);
  const [oldSiteSettingsData, setOldSiteSettingsData] = useState(null);

  const [maxDate, setmaxDate] = useState();
  const [minDate, setMinDate] = useState();
  const [roundsStartTime, setRoundsStartTime] = useState([]);
  const [restrictedRoundsStartTime, setRestrictedRoundsStartTime] = useState(
    []
  );
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [teeMinValue, setTeeMinValue] = useState(0);
  const [teemaxValue, setTeeMaxValue] = useState(0);
  const [paceStartTime, setPaceStartTime] = useState(0);
  const [customStep, setCustomStep] = useState();
  const [outsideClick, setOutsideClick] = useState(false);
  const [outsideClick1, setOutsideClick1] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);

  useEffect(() => {
          if(Object.keys(siteSettingsData).length > 0) {
              if(!siteSettingsData?.Features?.includes(featureKey.golf)) {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (siteIdData === null && Object?.keys(siteSettingsData)?.length !== 0)
      setsiteIdData(siteSettingsData?.Courses[0].Number);
    setCourseList(siteSettingsData);
  }, [siteSettingsData]);
  let totalTargetPace = 0;

  const dispatch = useDispatch();

  useEffect(() => {
    setBulletDataArray([]);
    setPaceByDate([]);
    setPaceStartTime([]);
    setRoundsStartTime([]);
    setPaceValues([]);

    setCourseIndex(selectedCourseIndexByHole(getPaceByHoleState));
  }, [paceReportsSelectedCourse]);

  const handleCourseName = (e) => {
    let courseData = JSON.parse(e.target.value);
    setPaceReportsSelectedCourse(courseData.Number);
    setCourseSelect(e.target.value);
    setsiteIdData(courseData.Id);
    globalCourseId.set(courseData.Id);
    dispatch(
      setAppDataReduxStateAction({
        value: courseData.Id,
        parameterDetector: "coursenumber",
      })
    );
  };

  const handleChange = (event) => {
    setTimeIncrement(event.target.value);
  };

  useEffect(() => {
    // setRefreshChart(false);
    setRefreshChartHoleTime(false);
    setRefreshChartHolePace(false);
    setRefreshChartAvgTime(false);
    setRefreshChartRounds(false);
    setRefreshChartAvgTee(false);
    setRefreshChartTeeRound(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  useEffect(() => {
    setRefreshChartHoleTime(true);
    setTimeout(() => setRefreshChartHoleTime(false), 2000);

    setRefreshChartHolePace(true);
    setTimeout(() => setRefreshChartHolePace(false), 2000);

    setRefreshChartAvgTime(true);
    setTimeout(() => setRefreshChartAvgTime(false), 2000);

    setRefreshChartRounds(true);
    setTimeout(() => setRefreshChartRounds(false), 2000);

    setRefreshChartAvgTee(true);
    setTimeout(() => setRefreshChartAvgTee(false), 2000);

    setRefreshChartTeeRound(true);
    setTimeout(() => setRefreshChartTeeRound(false), 2000);
  }, [siteIdData]);

  useEffect(() => {
    const currentMonth = moment().format("MMM");
    const currentYear = moment().format("YYYY");
    setMonthLabel(currentMonth.toString());
    setYearLabel(currentYear.toString());
    const quaterVal = moment().quarter();
    setQuaterLabel("Q" + quaterVal);
    showMonthlyData();
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(siteSettingsData) !==
      JSON.stringify(oldSiteSettingsData) &&
      Object.keys(siteSettingsData).length > 0
    ) {
      dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));
    }

    setOldSiteSettingsData({ ...siteSettingsData });
  }, [siteSettingsData]);

  useEffect(() => {
    refreshFunc();
  }, [getRoundTimeOutData]);

  useEffect(() => {
    if (
      JSON.stringify(siteSettingsData) !==
      JSON.stringify(oldSiteSettingsData) &&
      Object.keys(siteSettingsData).length > 0
    ) {
      dispatch(
        COMMON_SERVICES.getRoundsByDayServices(
          siteId.get(),
          convertToUTC(startDate),
          convertToUTC(endDate),
          60 / timeIncrement,
          startTimeHours,
          startTimeMinutes,
          endTimeHours,
          endTimeMinutes
        )
      );
      setOldSiteSettingsData({ ...siteSettingsData });
    }
  }, [siteId.get()]);

  const convertToUTC = (startDateIn) => {
    let utcStart = new Date(startDateIn);
    utcStart = new moment(utcStart);
    utcStart.utcOffset(0);
    utcStart.set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    });
    utcStart.utc();
    utcStart = utcStart.format("YYYY-MM-DDTHH:mm:ss.SSS");
    return utcStart;
  };

  const refreshFunc = () => {
    setBulletDataArray([]);
    setPaceByDate([]);
    setPaceStartTime([]);
    setRoundsStartTime([]);
    setPaceValues([]);

    dispatch(
      COMMON_SERVICES.getPaceByHoleServices(
        siteId.get(),
        convertToUTC(startDate),
        convertToUTC(endDate)
      )
    );
    dispatch(
      COMMON_SERVICES.getRoundsByDayServices(
        siteId.get(),
        convertToUTC(startDate),
        convertToUTC(endDate),
        60 / timeIncrement,
        startTimeHours,
        startTimeMinutes,
        endTimeHours,
        endTimeMinutes
      )
    );

    setRefreshChartHoleTime(true);
    setTimeout(() => setRefreshChartHoleTime(false), 2000);

    setRefreshChartHolePace(true);
    setTimeout(() => setRefreshChartHolePace(false), 2000);

    setRefreshChartAvgTime(true);
    setTimeout(() => setRefreshChartAvgTime(false), 2000);

    setRefreshChartRounds(true);
    setTimeout(() => setRefreshChartRounds(false), 2000);

    setRefreshChartAvgTee(true);
    setTimeout(() => setRefreshChartAvgTee(false), 2000);

    setRefreshChartTeeRound(true);
    setTimeout(() => setRefreshChartTeeRound(false), 2000);
  };
  const showYearlyData = () => {
    setMtdState(false);
    setQtdState(false);
    setYTDState(true);
    setStartDate(moment().set({ date: 1, month: 0 }));
    setEndDate(moment(new Date()));
  };

  const showQuaterlyData = () => {
    setMtdState(false);
    setQtdState(true);
    setYTDState(false);
    let getQuater = Math.floor(moment().month() / 3);
    setStartDate(moment().set({ date: 1, month: getQuater * 3 }));
    setEndDate(moment(new Date()));
  };
  const showMonthlyData = () => {
    setMtdState(true);
    setQtdState(false);
    setYTDState(false);
    setStartDate(moment().set("date", 1));
    setEndDate(moment(new Date()));
  };
  const startTime = (e) => {
    setStartTimeState(e.target.value);
    let timeData = e.target.value;
    let [hours, mins] = timeData.split(":");
    setStartTimeHours(hours);
    setStartTimeMinutes(mins);
  };
  const endTime = (e) => {
    setEndTimeState(e.target.value);
    let timeData = e.target.value;
    let [hours, mins] = timeData.split(":");
    setEndTimeHours(hours);
    setEndTimeMinutes(mins);
  };
  let paceReportsCourseList =
    courseList && courseList?.Courses && courseList?.Courses?.length;

  function selectedCourseIndexByHole(paceDataH) {
    if (
      paceReportsCourseList > 1 &&
      paceDataH &&
      Object?.keys(paceDataH)?.length !== 0
    ) {
      if (paceDataH?.Courses) {
        for (var i = 0; i < paceDataH?.Courses?.length; i++) {
          if (paceDataH?.Courses[i]?.Number === paceReportsSelectedCourse) {
            return i;
          }
        }
      }
    }
    return 0;
  }

  const activeBtn = {
    background: "var(--theme-background)",
    fontWeight: "bold",
  };

  const [avgHoleLabels, setAvgHoleLabels] = useState([]);
  const [avgTimeValues, setAvgTimeValues] = useState([]);
  const [targetValues, setTargetValues] = useState([]);
  const [bulletDataArray, setBulletDataArray] = useState([]);

  useEffect(() => {
    if (getPaceByHoleState && Object?.keys(getPaceByHoleState)?.length !== 0) {
      let tempAvgHoleLabels = [];
      let tempAvgTimeValues = [];
      let tempTargetValues = [];
      let tempBulletDataArray = [];

      for (
        var i = 0,
        paceArraylength =
          getPaceByHoleState.Courses[courseIndex].AveragePace.length;
        i < paceArraylength;
        i++
      ) {
        tempAvgHoleLabels.push(i + 1);
        tempAvgTimeValues.push(
          getPaceByHoleState.Courses[courseIndex].TargetPace[i] -
          getPaceByHoleState.Courses[courseIndex].AveragePace[i]
        );
        tempTargetValues.push(
          getPaceByHoleState.Courses[courseIndex].TargetPace[i]
        );
      }

      for (var j = 0, length = tempAvgHoleLabels.length; j < length; j++) {
        tempBulletDataArray.push({
          current: tempAvgTimeValues[j],
          target: tempTargetValues[j],
          category: tempAvgHoleLabels[j],
        });
      }

      // pace value

      let tempPaceValues =
        getPaceByHoleState &&
        Object.keys(getPaceByHoleState).length !== 0 &&
        getPaceByHoleState?.Courses[courseIndex]?.AveragePace?.map(
          (item) => item * -1
        );

      setAvgHoleLabels([...tempAvgHoleLabels]);
      setAvgTimeValues([...tempAvgTimeValues]);
      setTargetValues([...tempTargetValues]);
      setBulletDataArray([...tempBulletDataArray]);
      setPaceValues([...tempPaceValues]);
    }
  }, [getPaceByHoleState, courseIndex]);

  function areAllPaceByHoleValuesZero(data, prop) {
    if (data && data !== null && data !== undefined) {
      if (Object?.keys(data)?.length !== 0) {
        var result = data?.Courses[courseIndex][prop]?.every(function (
          element,
          index,
          array
        ) {
          return element === 0;
        });
        return result;
      }
    }
  }
  function areAllRoundsByDayValuesZero(data, prop1) {
    if (data && data !== null && data !== undefined) {
      if (Object?.keys(data)?.length !== 0) {
        var result = data[courseIndex]?.RoundsByDay?.every(function (
          element,
          index,
          array
        ) {
          return element[prop1] === 0;
        });
        return result;
      }
    }
  }
  function areAllRoundsByStartTimeValuesZero(data, prop1) {
    if (data && data !== null && data !== undefined) {
      if (Object?.keys(data)?.length !== 0) {
        var result = data[courseIndex]?.RoundsCourse?.every(function (
          element,
          index,
          array
        ) {
          return element[prop1] === 0;
        });
        return result;
      }
    }
  }

  function formatSecsToHoursMins(valueForFormat) {
    var formattedTime = null;
    var absValTime = null;
    if (valueForFormat >= 0) {
      formattedTime = moment()
        .startOf("day")
        .seconds(valueForFormat)
        .format("HH:mm");
    } else {
      absValTime = Math.abs(valueForFormat);
      formattedTime =
        "-" + moment().startOf("day").seconds(absValTime).format("HH:mm");
    }
    return formattedTime;
  }

  function formatSecsToMinsSecs(valueToFormat) {
    var formattedTime = null;
    var absValTime = null;
    if (valueToFormat >= 3600 || valueToFormat <= -3600) {
      if (valueToFormat >= 0) {
        formattedTime = moment()
          .startOf("day")
          .seconds(valueToFormat)
          .format("HH:mm:ss");
      } else {
        absValTime = Math.abs(valueToFormat);
        formattedTime =
          "-" + moment().startOf("day").seconds(absValTime).format("HH:mm:ss");
      }
    } else {
      if (valueToFormat >= 0) {
        formattedTime = moment()
          .startOf("day")
          .seconds(valueToFormat)
          .format("mm:ss");
      } else {
        absValTime = Math.abs(valueToFormat);
        formattedTime =
          "-" + moment().startOf("day").seconds(absValTime).format("mm:ss");
      }
    }
    return formattedTime;
  }
  const SharedAveragePaceTooltip = (props) => {
    const { points } = props;
    var formattedValue = formatSecsToMinsSecs(points[0].value);

    return points[0].value === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "red" : "green",
          padding: "0px 5px 0px 5px",
        }}
      >
        {points[0].value > 0
          ? formattedValue + " " + t("behind")
          : formattedValue.replace("-", "") + " " + t("ahead")}
      </div>
    );
  };
  const SharedKWHoursTooltip = (props) => {
    const { points } = props;

    var arrayIndex = points[0].categoryIndex;
    var totalTime = formatSecsToMinsSecs(avgTimeValues[arrayIndex]);
    var targettedTime = formatSecsToMinsSecs(targetValues[arrayIndex]);
    var paceDiff = formatSecsToMinsSecs(
      avgTimeValues[arrayIndex] - targetValues[arrayIndex]
    );

    return points[0].value.current === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor:
            avgTimeValues[arrayIndex] - targetValues[arrayIndex] > 0
              ? "red"
              : "green",
          padding: "0px 5px 0px 5px",
        }}
      >
        <div>
          {t("Actual")}:{totalTime}
        </div>
        <div>
          {t("Target")}:{targettedTime}
        </div>
        <div>
          {t("Difference")}:{paceDiff}
        </div>
      </div>
    );
  };

  const SharedAverageTimeByTeeTimeTooltip = (props) => {
    const { points } = props;

    var formattedValue = formatSecsToMinsSecs(Math.round(points[0].value));
    formattedValue =
      points[0].value > 0
        ? formattedValue + " " + t("behind")
        : formattedValue.replace("-", "") + " " + t("ahead");
    var targetTime = getTotalTargetTime();
    var formattedRoundTime = targetTime + Math.round(points[0].value);
    formattedRoundTime = formatSecsToHoursMins(formattedRoundTime);
    return points[0].value === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "red" : "green",
          padding: "0px 5px 0px 5px",
        }}
      >
        <div>
          {t("Tee_Time")}: {moment(points[0].category).format("HH:mm")}
        </div>
        <div>
          {t("Pace")}: {formattedValue}
        </div>
        <div>
          {t("Round_Time")}: {formattedRoundTime}
        </div>
      </div>
    );
  };
  const SharedRoundsByTeeTimeTooltip = (props) => {
    const { points } = props;
    return points[0].value === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "green" : "red",
          padding: "0px 5px 0px 5px",
        }}
      >
        {t("Tee_Time")}: {moment(points[0].category).format("HH:mm")},{" "}
        {Math.round(points[0].value)} {t("Rounds")}
      </div>
    );
  };

  const SharedTimesByDayTooltip = (props) => {
    const { points } = props;
    var targetTime = getTotalTargetTime();
    var formattedValue = formatSecsToMinsSecs(Math.round(points[0].value));
    formattedValue =
      points[0].value > 0
        ? formattedValue + " " + t("behind")
        : formattedValue.replace("-", "") + " " + t("ahead");
    var formattedRoundTime = targetTime + Math.round(points[0].value);
    formattedRoundTime = formatSecsToHoursMins(formattedRoundTime);

    return points[0].value === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "red" : "green",
          padding: "0px 5px 0px 5px",
        }}
      >
        <div>{moment.utc(points[0].category).format("DD-MMM-YYYY")}</div>
        <div>
          {t("Pace")}: {formattedValue}
        </div>
        <div>
          {t("Round_Time")}: {formattedRoundTime}
        </div>
      </div>
    );
  };
  const SharedRoundsByDayTooltip = (props) => {
    const { points } = props;
    return points[0].value === 0 ? (
      ""
    ) : (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "green" : "red",
          padding: "0px 5px 0px 5px",
        }}
      >
        {Math.round(points[0].value) +
          " " +
          t("Rounds") +
          " " +
          moment.utc(points[0].category).format("DD-MMM-YYYY")}
      </div>
    );
  };
  function getChartSettings(chartData, chartName) {
    let tempChartInfo = {
      chartBaseUnits: "days",
      chartTitle: "",
    };
    if (chartData !== null && chartData?.length < 32) {
      tempChartInfo.chartBaseUnits = "days";
      tempChartInfo.chartTitle = `Average ${chartName} by Day`;
    } else {
      if (
        chartData !== null &&
        chartData?.length > 31 &&
        chartData?.length < 120
      ) {
        tempChartInfo.chartBaseUnits = "weeks";
        tempChartInfo.chartTitle = t(
          `Average ${chartName} by Week`
        );
      } else {
        tempChartInfo.chartBaseUnits = "months";
        tempChartInfo.chartTitle =
          `Average ${chartName} by Month`;
      }
    }
    return tempChartInfo;
  }

  useEffect(() => {
    setChartInfoState(getChartSettings(paceByDate, "Rounds"));
    setChartTimeInfoState(getChartSettings(paceByDate, "Times"));
  }, [startDate, endDate, paceByDate]);

  useEffect(() => {
    if (ChartInfoState !== null) {
      if (Object?.keys(ChartInfoState)?.length !== 0) {
        if (ChartInfoState.chartBaseUnits === "days") {
          setChartTitleValueState("Rounds by day");
        }
        if (ChartInfoState.chartBaseUnits === "weeks") {
          setChartTitleValueState("Average daily rounds by week");
        }
        if (ChartInfoState.chartBaseUnits === "months") {
          setChartTitleValueState("Average daily rounds by month");
        }
      }
    }
  }, [ChartInfoState]);

  function getTotalTargetTime() {
    var tempCourse = null;
    var tempTargetAvg = 0;

    if (
      Object?.keys(getRoundTimeOutData)?.length !== 0 &&
      getRoundTimeOutData?.site?.Courses?.Course.length
    ) {
      if (
        getRoundTimeOutData &&
        getRoundTimeOutData?.site?.Courses?.Course.length > 0
      ) {
        for (
          var i = 0;
          i < getRoundTimeOutData?.site?.Courses?.Course.length;
          i++
        ) {
          if (
            getRoundTimeOutData?.site?.Courses?.Course[i].$CourseNumber ===
            paceReportsSelectedCourse.toString()
          ) {
            tempCourse =
              getRoundTimeOutData?.site?.Courses?.Course[i]?.Holes?.Hole;
          }
        }
      } else {
        tempCourse =
          getRoundTimeOutData &&
          getRoundTimeOutData?.site?.Courses?.Course?.Holes?.Hole;
      }

      for (var j = 0; j < tempCourse.length; j++) {
        tempTargetAvg += parseInt(tempCourse[j].PaceInSeconds, 10);
      }
    }
    return tempTargetAvg;
  }

  function getRoundsStartTimeReady(cIndex, dataToReady) {
    if (dataToReady) {
      if (getRoundTimeOutData) {
        totalTargetPace = getTotalTargetTime();
      } else {
        totalTargetPace = 14400; //4 hours, default for testing when no pace settings available---to be deleted later
      }
      var roundsPaceStartTime = [];
      for (
        var i = 0, length = dataToReady[cIndex]?.RoundsCourse.length;
        i < length;
        i++
      ) {
        var datum = {
          roundsValue: dataToReady[cIndex]?.RoundsCourse[i]?.Rounds,
          paceValue: dataToReady[cIndex]?.RoundsCourse[i]?.AveragePace * -1,
          timeValue:
            dataToReady[cIndex]?.RoundsCourse[i]?.Rounds > 0
              ? totalTargetPace -
              dataToReady[cIndex]?.RoundsCourse[i]?.AveragePace
              : 0, //to account for start of day
          date: new Date(
            moment
              .utc(dataToReady[cIndex]?.RoundsCourse[i]?.Date)
              .format("YYYY/MMM/DD HH:mm:ss")
          ),
        };
        roundsPaceStartTime.push(datum);
      }
      // }

      return roundsPaceStartTime;
    }
  }

  function getPaceByDayDataReady(cIndex, dataToReady) {
    let temp = [];
    if (getRoundTimeOutData) {
      totalTargetPace = getTotalTargetTime();
    } else {
      totalTargetPace = 14400; //4 hours, default for testing when no pace settings available---to be deleted later
    }

    if (dataToReady && Object.keys(dataToReady).length !== 0) {
      for (
        var i = 0, length = dataToReady[cIndex]?.RoundsByDay.length;
        i < length;
        i++
      ) {
        var datum = {
          roundsValue: dataToReady[cIndex]?.RoundsByDay[i]?.Rounds,
          paceValue: dataToReady[cIndex]?.RoundsByDay[i]?.AveragePace * -1,
          timeValue:
            dataToReady[cIndex]?.RoundsByDay[i]?.Rounds > 0
              ? totalTargetPace -
              dataToReady[cIndex]?.RoundsByDay[i]?.AveragePace
              : 0, //to account for start of day
          date: new Date(
            moment
              .utc(dataToReady[cIndex]?.RoundsByDay[i]?.Date)
              .format("YYYY/MMM/DD")
          ),
        };
        temp.push(datum);
      }
    }

    setPaceByDate([...temp]);
  }

  useEffect(() => {
    if (getRoundsByDayState) {
      getPaceByDayDataReady(courseIndex, getRoundsByDayState);

      let splitTime;

      splitTime = startTimeState.split(":");
      let selectedStartTeeTime = new Date(2000, 0, 1, ...splitTime);

      splitTime = endTimeState.split(":");
      let selectedEndTeeTime = new Date(2000, 0, 1, ...splitTime);

      let tempPaceStartTime = getRoundsStartTimeReady(
        courseIndex,
        getRoundsByDayState
      );

      setPaceStartTime(tempPaceStartTime);

      if (
        roundsStartTime &&
        roundsStartTime.length === 0 &&
        tempPaceStartTime.length !== 0 &&
        JSON.stringify(roundsStartTime) !== JSON.stringify(tempPaceStartTime)
      ) {
        setRoundsStartTime(tempPaceStartTime);
      }

      let minValue2 = tempPaceStartTime.length
        ? Math.min.apply(null, _.map(tempPaceStartTime, "paceValue"))
        : 1;
      let maxValue2 = tempPaceStartTime.length
        ? Math.max.apply(null, _.map(tempPaceStartTime, "paceValue"))
        : 1;

      setTeeMinValue(minValue2);
      setTeeMaxValue(maxValue2);
      let f = tempPaceStartTime[0]?.date;
      if (f !== undefined) {
        setMinDate(
          new Date(
            2000,
            f.getMonth(),
            f.getDate(),
            selectedStartTeeTime.getHours(),
            selectedStartTeeTime.getMinutes(),
            0,
            0
          )
        );
        setmaxDate(
          new Date(
            2000,
            f.getMonth(),
            f.getDate(),
            selectedEndTeeTime.getHours(),
            selectedEndTeeTime.getMinutes(),
            0,
            0
          )
        );
      }

      let a = moment(maxDate);
      let b = moment(minDate);
      let hours = a.diff(b, "hours");

      setCustomStep(
        // hours * Math.floor(60 / selectedTimeIncrement) < 32 ? 1 : 3
        hours * Math.floor(60 / (60 / timeIncrement)) < 32 ? 1 : 3
      ); // 32 is highest number of labels before to close together
    }
  }, [getRoundsByDayState, courseIndex]);

  useEffect(() => {
    // let tempMaxValue = maxValue;
    // let tempMinValue = minValue;
    let tempMaxValue = 0;
    let tempMinValue = 0;
    for (let i = 0; i < paceByDate.length; i++) {
      if (paceByDate[i].paceValue > tempMaxValue) {
        // setMaxValue(paceByDate[i].paceValue)
        tempMaxValue = paceByDate[i].paceValue;
      }
      if (paceByDate[i].paceValue < tempMinValue) {
        // setMinValue(paceByDate[i].paceValue)
        tempMinValue = paceByDate[i].paceValue;
      }
    }
    // setMinValue(Math.floor(tempMinValue / 500) * 500)
    // setMaxValue(Math.ceil(tempMaxValue / 500) * 500) //add padding for bars by rounding to same value as majorUnit below to try to keep 0 pace and target time axis labels displayed and synced

    setMinValue(tempMinValue);
    setMaxValue(tempMaxValue);
  }, [paceByDate]);

  useEffect(() => {
    setRefreshChartHoleTime(true);
    setTimeout(() => setRefreshChartHoleTime(false), 2000);
  }, [bulletDataArray]);

  useEffect(() => {
    setRefreshChartAvgTime(true);
    setTimeout(() => setRefreshChartAvgTime(false), 2000);

    setRefreshChartRounds(true);
    setTimeout(() => setRefreshChartRounds(false), 2000);
  }, [paceByDate]);

  useEffect(() => {
    setRefreshChartAvgTee(true);
    setTimeout(() => setRefreshChartAvgTee(false), 2000);
  }, [paceStartTime]);

  useEffect(() => {
    setRefreshChartTeeRound(true);
    setTimeout(() => setRefreshChartTeeRound(false), 2000);
  }, [roundsStartTime]);

  useEffect(() => {
    setRefreshChartHolePace(true);
    setTimeout(() => setRefreshChartHolePace(false), 2000);
  }, [paceValues]);

  const [roundTeeMinDate, setRoundTeeMinDate] = useState();
  const [roundTeeMaxDate, setRoundTeeMaxDate] = useState();

  useEffect(() => {
    if (roundsStartTime && roundsStartTime.length > 0) {
      let f = roundsStartTime[0].date;
      // let selectedStartTeeTime = new Date(2000, 0, 1, 7, 0, 0);
      // let selectedEndTeeTime = new Date(2000, 0, 1, 16, 30, 0);

      let splitTime;

      splitTime = startTimeState.split(":");
      let selectedStartTeeTime = new Date(2000, 0, 1, ...splitTime);

      splitTime = endTimeState.split(":");
      let selectedEndTeeTime = new Date(2000, 0, 1, ...splitTime);

      // let selectedStartTeeTime = new Date(startTimeState);
      // let selectedEndTeeTime = new Date(endTimeState);

      let minDate = new Date(
        2000,
        f.getMonth(),
        f.getDate(),
        selectedStartTeeTime.getHours(),
        selectedStartTeeTime.getMinutes(),
        0,
        0
      );
      let maxDate = new Date(
        2000,
        f.getMonth(),
        f.getDate(),
        selectedEndTeeTime.getHours(),
        selectedEndTeeTime.getMinutes(),
        0,
        0
      );
      setRoundTeeMinDate(minDate);
      setRoundTeeMaxDate(maxDate);
    }
  }, [roundsStartTime]);

  useEffect(() => {
    setRefreshChartTeeRound(true);
    setTimeout(() => setRefreshChartTeeRound(false), 2000);
  }, [roundTeeMinDate, roundTeeMaxDate]);

  let roundsByTeeTime = paceByDate && paceByDate.map((item) => item.date);
  let category2 = roundsStartTime && roundsStartTime.map((item) => item.date);

  const handleChartRefreshHoleTime = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartHoleTime) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleChartRefreshHolePace = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartHolePace) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleChartRefreshAvgTime = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartAvgTime) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleChartRefreshRounds = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartRounds) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleChartRefreshAvgTee = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartAvgTee) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleChartRefreshTeeRound = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartTeeRound) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const sharedKWHoursTooltipRender = (contexts) => (
    <SharedKWHoursTooltip {...contexts} />
  );
  const sharedAveragePaceTooltipRender = (contexts) => (
    <SharedAveragePaceTooltip {...contexts} />
  );
  const sharedRoundsByDayTooltipRender = (contexts) => (
    <SharedRoundsByDayTooltip {...contexts} />
  );
  const sharedAverageTimesByDayTooltipRender = (contexts) => (
    <SharedTimesByDayTooltip {...contexts} />
  );
  const sharedRoundsByTeeTimeTooltipRender = (contexts) => (
    <SharedRoundsByTeeTimeTooltip {...contexts} />
  );
  const sharedAverageTimesByTeeTimeTooltipRender = (contexts) => (
    <SharedAverageTimeByTeeTimeTooltip {...contexts} />
  );

  useEffect(() => {
    if (startDate > endDate) {
      setEndDate(startDate);
    }
  }, [startDate]);

  useEffect(() => {
    if (startDate > endDate) {
      setStartDate(endDate);
    }
  }, [endDate]);

  useEffect(() => {
    if (
      roundsStartTime.length !== 0 &&
      JSON.stringify(roundsStartTime) !==
      JSON.stringify(restrictedRoundsStartTime)
    ) {
      setRestrictedRoundsStartTime([...roundsStartTime]);
    }
  }, [roundsStartTime]);

  return (
    <Wrapper>
      <SortingHeader>
        <div className="label-wrapper">
          <label name="start">{t("Start")}</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ClickAwayListener
              onClickAway={() => {
                if (outsideClick) {
                  setStartDate(new Date(startDate));
                  setDisabledButton(false);
                  setOutsideClick(false);
                }
              }}
            >
              <DatePicker
                name="start"
                inputFormat="DD-MMM-YYYY"
                label=""
                value={startDate}
                onChange={(newValue) => {
                  if (newValue && newValue.format() !== "Invalid Date") {
                    setStartDate(newValue);
                    setDisabledButton(false);
                  } else {
                    if (newValue === null) {
                      setOutsideClick(true);
                      setDisabledButton(true);
                    } else {
                      setDisabledButton(true);
                    }
                  }
                }}
                renderInput={(params) => <TextField {...params} />}
                PaperProps={{
                  sx: {
                    maxHeight: 350,
                    "& .MuiPickersLayout-contentWrapper": {
                      mb: 0,
                    }
                  }
                }}
                components={{
                  ActionBar: (props) => (
                    <TodayDateActionBar
                      onToday={() => {
                        const today = moment().startOf("day");
                        if (today && today.format() !== "Invalid Date") {
                          setStartDate(today);
                          setDisabledButton(false);
                          props.onAccept?.();
                          props.onClose?.();
                        } else {
                          if (today === null) {
                            setOutsideClick(true);
                            setDisabledButton(true);
                          } else {
                            setDisabledButton(true);
                          }
                        }
                      }}
                    />
                  ),
                }}
              />
            </ClickAwayListener>
          </LocalizationProvider>
          <span style={{ color: "red", fontWeight: "bold" }}>
            {errorHandler.startDateError && errorHandler.startDateError}
          </span>
          <label name="End">{t("End")}</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ClickAwayListener
              onClickAway={() => {
                if (outsideClick1) {
                  setEndDate(new Date(endDate));
                  setDisabledButton(false);
                  setOutsideClick1(false);
                }
              }}
            >
              <DatePicker
                name="End"
                inputFormat="DD-MMM-YYYY"
                label=""
                value={endDate}
                onChange={(newValue) => {
                  if (newValue && newValue.format() !== "Invalid Date") {
                    setEndDate(newValue);
                    setDisabledButton(false);
                  } else {
                    if (newValue === null) {
                      setDisabledButton(true);
                      setOutsideClick1(true);
                    } else {
                      setDisabledButton(true);
                    }
                  }
                }}
                renderInput={(params) => <TextField {...params} />}
                PaperProps={{
                  sx: {
                    maxHeight: 350,
                    "& .MuiPickersLayout-contentWrapper": {
                      mb: 0,
                    }
                  }
                }}
                components={{
                  ActionBar: (props) => (
                    <TodayDateActionBar
                      onToday={() => {
                        const today = moment().startOf("day");
                        if (today && today.format() !== "Invalid Date") {
                          setEndDate(today);
                          setDisabledButton(false);
                          props.onAccept?.();
                          props.onClose?.();
                        } else {
                          if (today === null) {
                            setDisabledButton(true);
                            setOutsideClick1(true);
                          } else {
                            setDisabledButton(true);
                          }
                        }
                      }}
                    />
                  ),
                }}
              />
            </ClickAwayListener>
          </LocalizationProvider>
        </div>

        <div className="btn-header-wrapper">
          <Tooltip title={t("Show_month_to_date")}>
            <CircleBtn
              style={MtdState ? activeBtn : null}
              onClick={showMonthlyData}
            >
              {monthLabel}
            </CircleBtn>
          </Tooltip>

          <Tooltip title={t("Show_quarter_to_date")}>
            <CircleBtn
              style={QtdState ? activeBtn : null}
              onClick={showQuaterlyData}
            >
              {quaterLabel}
            </CircleBtn>
          </Tooltip>

          <Tooltip title={t("Show_year_to_date")}>
            <CircleBtn
              style={YTDState ? activeBtn : null}
              onClick={showYearlyData}
            >
              {yearLabel}
            </CircleBtn>
          </Tooltip>
        </div>
        <div className="label-wrapper">
          <FormControl fullWidth size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={timeIncrement}
              onChange={handleChange}
            >
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={6}>6</MenuItem>
              <MenuItem value={8}>8</MenuItem>
            </Select>
          </FormControl>
          <p className="hr">/hr</p>
        </div>
        <div className="label-wrapper">
          <label name="Start">{t("Start")}</label>
          <input
            name="Start"
            type="time"
            value={startTimeState}
            onChange={(e) => startTime(e)}
          />
          <label name="End">{t("End")}</label>
          <input
            name="End"
            type="time"
            value={endTimeState}
            onChange={(e) => endTime(e)}
          />
        </div>
        <div className="btn-header-wrapper">
          <Tooltip title={t("Refresh")}>
            <CircleBtn disabled={disabledButton} onClick={() => refreshFunc()}>
              {t("Refresh")}
            </CircleBtn>
          </Tooltip>
          <FormControl size="small">
            <Select
              native
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              variant="outlined"
              value={courseSelect}
              onChange={handleCourseName}
              IconComponent={() => (
                <div className="arrow-icon">
                  <SelectArrow />
                </div>
              )}
            >
              {/* <option value="">Select Course</option> */}
              {courseList &&
                courseList?.Courses &&
                courseList?.Courses.length !== 0 ? (
                courseList.Courses.map((item, index) => (
                  <option
                    key={item.Id}
                    id={item.Id}
                    value={JSON.stringify(item)}
                  >
                    {item.Name}
                  </option>
                ))
              ) : (
                <option value=""></option>
              )}
            </Select>
          </FormControl>
        </div>
      </SortingHeader>
      <UsageContainer>
        {/* chart section start */}

        <ChartRow>
          <div>
            {bulletDataArray &&
              bulletDataArray !== undefined &&
              bulletDataArray !== null &&
              bulletDataArray.length > 0 &&
              courseIndex !== undefined &&
              !areAllPaceByHoleValuesZero(getPaceByHoleState, "AveragePace") ? (
              <>
                <Chart onRefresh={handleChartRefreshHoleTime}>
                  <ChartLegend visible={false} />
                  <ChartTitle
                    text={t("Average_Time_per_Hole") + " (mm:ss)"}
                    font="14pt sans-serif"
                  />

                  <ChartSeriesDefaults type="column" gap={1} />

                  <ChartSeries>
                    <ChartSeriesItem
                      type="verticalBullet"
                      overlay={{ gradient: "glass" }}
                      color={function (e) {
                        var arrayIndex = e.index;
                        if (
                          avgTimeValues[arrayIndex] - targetValues[arrayIndex] >
                          0
                        ) {
                          return "red";
                        } else {
                          return "green";
                        }
                      }}
                      target={{
                        color: "#5a4731",
                        line: {
                          width: 3,
                        },
                      }}
                      currentField="current"
                      targetField="target"
                      gap={1}
                      data={bulletDataArray}
                    />
                  </ChartSeries>
                  <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                      majorGridLines={{ visible: true, color: "#D4D4D4" }}
                      minorTicks={{ visible: false }}
                      field={"category"}
                      labels={{ visible: true }}
                      categories={avgHoleLabels}
                    />
                  </ChartCategoryAxis>
                  <ChartValueAxis>
                    <ChartValueAxisItem
                      majorGridLines={{ visible: true, color: "#D4D4D4" }}
                      min={0}
                      labels={{
                        template: function (e) {
                          return formatSecsToMinsSecs(e.value);
                        },
                      }}

                    // axisCrossingValue={[0, -99999]}
                    // line={{ visible: false }}
                    />
                  </ChartValueAxis>
                  <ChartTooltip
                    border={{ color: "transparent" }}
                    render={sharedKWHoursTooltipRender}
                    background="transparent"
                    color="white"
                    shared={true}
                    visible={true}
                  />
                </Chart>
              </>
            ) : (
              <>
                <strong>{t("Average_Pace_per_Hole")} (mm:ss)</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            {paceValues &&
              paceValues !== undefined &&
              paceValues !== null &&
              courseIndex !== undefined &&
              !areAllPaceByHoleValuesZero(getPaceByHoleState, "AveragePace") ? (
              <Chart onRefresh={handleChartRefreshHolePace}>
                <ChartLegend visible={false} />
                <ChartTitle
                  text={t("Average_Pace_per_Hole") + " (mm:ss)"}
                  font="14pt sans-serif"
                />
                <ChartSeriesItemTooltip
                  border={{ color: "transparent" }}
                  render={sharedAveragePaceTooltipRender}
                  background="transparent"
                  color="white"
                  shared={true}
                  visible={true}
                />

                <ChartSeriesDefaults type="column" gap={1} />

                <ChartValueAxis>
                  <ChartValueAxisItem
                    line={{ visible: false }}
                    axisCrossingValue={[0, -99999]}
                    labels={{
                      template: function (e) {
                        return formatSecsToMinsSecs(e.value);
                      },
                    }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={1}
                    color={(e) => {
                      if (e.value > 0) {
                        return "red";
                      } else {
                        return "green";
                      }
                    }}
                    data={paceValues}
                  />
                </ChartSeries>
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    categories={avgHoleLabels}
                    labels={{ visible: false }}
                    // majorGridLines={{ visible: true }}
                    majorGridLines={{ visible: true, color: "#D4D4D4" }}
                  // minorTicks={{ visible: false }}
                  />
                  <ChartCategoryAxisItem
                    categories={avgHoleLabels}
                    // majorGridLines={{ visible: true }}
                    majorGridLines={{ visible: true, color: "#D4D4D4" }}
                    axisCrossingValue={[-99999, 1]}
                  // minorTicks={{ visible: false }}
                  />
                </ChartCategoryAxis>
              </Chart>
            ) : (
              <>
                <strong>{t("Average_Pace_per_Hole")} (mm:ss)</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
        </ChartRow>
        {/* 3rd chart */}
        <ChartRow>
          <div>
            {paceByDate &&
              paceByDate !== undefined &&
              paceByDate !== null &&
              paceByDate.length > 0 &&
              ChartTimeInfoState !== null &&
              minValue !== undefined &&
              maxValue !== undefined &&
              courseIndex !== undefined &&
              ChartInfoState !== null &&
              !areAllRoundsByStartTimeValuesZero(
                getRoundsByDayState,
                "AveragePace"
              ) ? (
              <>
                <Chart onRefresh={handleChartRefreshAvgTime}>
                  <ChartLegend visible={false} />
                  <ChartTitle
                    text={
                      ChartTimeInfoState !== null &&
                      ChartTimeInfoState.chartTitle
                    }
                    font="14pt sans-serif"
                  />
                  <ChartTooltip
                    border={{ color: "transparent" }}
                    background="transparent"
                    color="white"
                    shared={true}
                    render={sharedAverageTimesByDayTooltipRender}
                    visible={true}
                  />
                  <ChartSeriesDefaults
                    type="column"
                    line={{ width: 5 }}
                    gap={1}
                  />

                  <ChartValueAxis>
                    <ChartValueAxisItem
                      name="Pace"
                      title={{
                        text: "Pace (mm:ss)",
                      }}
                      line={{ visible: true }}
                      majorTicks={{ visible: true }}
                      labels={{
                        template: function (e) {
                          return formatSecsToMinsSecs(e.value);
                        },
                        color: "black",
                      }}
                      axisCrossingValue={[0, -9999999999]}
                      min={Math.floor(minValue / 500) * 500}
                      max={Math.ceil(maxValue / 500) * 500}
                      step={500}
                    />
                    <ChartValueAxisItem
                      name="Time"
                      majorTicks={{ visible: true }}
                      min={
                        getTotalTargetTime() + Math.floor(minValue / 500) * 500
                      }
                      max={
                        getTotalTargetTime() + Math.ceil(maxValue / 500) * 500
                      }
                      axisCrossingValue={[0, getTotalTargetTime()]}
                      step={500}
                      title={{
                        text: t("Round_Time") + "(hh:mm)",
                      }}
                      line={{ visible: true }}
                      labels={{
                        template: function (e) {
                          return formatSecsToHoursMins(e.value);
                        },
                        color: "black",
                      }}
                    />
                  </ChartValueAxis>
                  <ChartCategoryAxis>
                    {minValue >= 0 ? (
                      <ChartCategoryAxisItem
                        // majorGridLines={{ visible: true }}
                        majorGridLines={{ visible: true, color: "#D4D4D4" }}
                        minorTicks={{ visible: false }}
                        baseUnit={
                          ChartInfoState !== null &&
                          ChartInfoState.chartBaseUnits
                        }
                        labels={{
                          rotation: -90,
                          template: function (e) {
                            return moment.utc(e.value).format("DD-MMM-YYYY");
                          },
                          padding: 0,
                          // position: "start",
                          margin: 0,
                        }}
                        type="date"
                        categories={roundsByTeeTime}
                        axisCrossingValue={[0, 999]}
                      />
                    ) : (
                      <ChartCategoryAxisItem
                        // majorGridLines={{ visible: true }}
                        majorGridLines={{ visible: true, color: "#D4D4D4" }}
                        minorTicks={{ visible: false }}
                        type="date"
                        baseUnit={
                          ChartInfoState !== null &&
                          ChartInfoState.chartBaseUnits
                        }
                        labels={{
                          rotation: -90,
                          template: function (e) {
                            return moment.utc(e.value).format("DD-MMM-YYYY");
                          },
                          padding: 0,
                          position: "start",
                          margin: 0,
                        }}
                        categories={roundsByTeeTime}
                        axisCrossingValue={[0, 999]}
                      />
                    )}
                  </ChartCategoryAxis>
                  <ChartSeries>
                    <ChartSeriesItem
                      name="Pace"
                      field="paceValue"
                      categoryField="date"
                      axis="Pace"
                      // gap={1}
                      labels={{ color: "black" }}
                      color={(e) => {
                        if (e.value < 0) {
                          return "green";
                        } else {
                          return "red";
                        }
                      }}
                      aggregate="avg"
                      type="column"
                      data={paceByDate}
                    />
                  </ChartSeries>
                </Chart>
              </>
            ) : (
              <>
                <strong>
                  {ChartTimeInfoState !== null && ChartTimeInfoState.chartTitle}
                </strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            {paceByDate &&
              paceByDate !== undefined &&
              paceByDate !== null &&
              courseIndex !== undefined &&
              !areAllRoundsByDayValuesZero(getRoundsByDayState, "Rounds") ? (
              <Chart onRefresh={handleChartRefreshRounds}>
                <ChartLegend visible={false} />
                <ChartTitle
                  text={ChartTitleValueState}
                  font="14pt sans-serif"
                />
                <ChartTooltip
                  border={{ color: "transparent" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedRoundsByDayTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults
                  type="column"
                  line={{ width: 5 }}
                  gap={1}
                />

                <ChartValueAxis>
                  <ChartValueAxisItem
                    name="Rounds"
                    min={0}
                    line={{ visible: true }}
                    labels={{
                      color: "black",
                    }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    name="Rounds"
                    field="roundsValue"
                    categoryField="date"
                    axis="Rounds"
                    gap={1}
                    labels={{ color: "black" }}
                    color="green"
                    aggregate="avg"
                    type="column"
                    data={paceByDate}
                  />
                </ChartSeries>
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    // majorGridLines={{ visible: true }}
                    majorGridLines={{ visible: true, color: "#D4D4D4" }}
                    minorTicks={{ visible: false }}
                    baseUnit={
                      ChartInfoState !== null && ChartInfoState.chartBaseUnits
                    }
                    type="date"
                    labels={{
                      rotation: -90,
                      template: function (e) {
                        return moment.utc(e.value).format("DD-MMM-YYYY");
                      },
                      padding: 0,
                      margin: 0,
                    }}
                    categories={roundsByTeeTime}
                  />
                </ChartCategoryAxis>
              </Chart>
            ) : (
              <>
                <strong>{ChartTitleValueState}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
        </ChartRow>
        {/* Average time by tee */}
        <ChartRow>
          <div>
            {paceStartTime &&
              paceStartTime !== undefined &&
              paceStartTime !== null &&
              courseIndex !== undefined &&
              !areAllRoundsByDayValuesZero(getRoundsByDayState, "AveragePace") ? (
              <Chart onRefresh={handleChartRefreshAvgTee}>
                <ChartLegend visible={false} />
                <ChartTitle
                  text={t("Average_Times_by_Tee_Time")}
                  font="14pt sans-serif"
                />
                <ChartTooltip
                  border={{ color: "transparent" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedAverageTimesByTeeTimeTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults
                  type="column"
                  line={{ width: 1, color: "black" }}
                  gap={1}
                />

                <ChartValueAxis>
                  <ChartValueAxisItem
                    name="Pace"
                    majorTicks={{ visible: true }}
                    min={Math.floor(teeMinValue / 500) * 500}
                    max={Math.ceil(teemaxValue / 500) * 500}
                    axisCrossingValue={[0, -9999999999]}
                    step={500}
                    title={{
                      text: t("Pace") + "(mm:ss)",
                    }}
                    line={{ visible: true }}
                    labels={{
                      template: function (e) {
                        return formatSecsToMinsSecs(e.value);
                      },
                      color: "black",
                    }}
                  />
                  <ChartValueAxisItem
                    name="Time"
                    majorTicks={{ visible: true }}
                    min={
                      getTotalTargetTime() + Math.floor(teeMinValue / 500) * 500
                    }
                    max={
                      getTotalTargetTime() + Math.ceil(teemaxValue / 500) * 500
                    }
                    axisCrossingValue={[0, getTotalTargetTime()]}
                    step={500}
                    title={{
                      text: t("Round_Time") + "(hh:mm)",
                    }}
                    line={{ visible: true }}
                    labels={{
                      template: function (e) {
                        return formatSecsToHoursMins(e.value);
                      },
                      color: "black",
                    }}
                  />
                </ChartValueAxis>

                <ChartCategoryAxis>
                  {teeMinValue >= 0 ? (
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        labels={{
                          visible: true,
                          rotation: -90,
                          template: function (e) {
                            return moment(e.value).format("HH:mm");
                          },
                          padding: 0,
                          margin: 0,
                          step: customStep,
                        }}
                        type="date"
                        min={minDate}
                        max={moment(maxDate).add(60 / timeIncrement, "minutes")}
                        baseUnit="seconds"
                        baseUnitStep={(60 / timeIncrement) * 60}
                        majorGridLines={{ visible: true, color: "#D4D4D4" }}
                        axisCrossingValue={[0, 999]}
                      />
                    </ChartCategoryAxis>
                  ) : (
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        labels={{ visible: false }}
                        type={"date"}
                        min={minDate}
                        max={moment(maxDate).add(60 / timeIncrement, "minutes")}
                        baseUnit="seconds"
                        baseUnitStep={(60 / timeIncrement) * 60}
                        majorGridLines={{ visible: true, color: "#D4D4D4" }}
                        axisCrossingValues={[0, 999]}
                      />
                      <ChartCategoryAxisItem
                        labels={{
                          visible: true,
                          rotation: -90,
                          template: function (e) {
                            return moment(e.value).format("HH:mm");
                          },
                          padding: 0,
                          margin: 0,
                          step: customStep,
                          // step: 3,
                        }}
                        type="date"
                        min={minDate}
                        max={moment(maxDate).add(60 / timeIncrement, "minutes")}
                        baseUnit="seconds"
                        baseUnitStep={(60 / timeIncrement) * 60}
                        majorGridLines={{ visible: true, color: "#D4D4D4" }}
                      />
                    </ChartCategoryAxis>
                  )}
                </ChartCategoryAxis>

                <ChartSeries>
                  <ChartSeriesItem
                    type="column"
                    name="Pace"
                    field="paceValue"
                    categoryField="date"
                    axis="Pace"
                    color={(e) => {
                      if (e.value < 0) {
                        return "green";
                      } else {
                        return "red";
                      }
                    }}
                    labels={{ color: "black" }}
                    data={paceStartTime}
                    transitions={false}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("Average_Times_by_Tee_Time")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            {restrictedRoundsStartTime &&
              restrictedRoundsStartTime !== undefined &&
              restrictedRoundsStartTime !== null &&
              courseIndex !== undefined &&
              !areAllRoundsByStartTimeValuesZero(
                getRoundsByDayState,
                "Rounds"
              ) ? (
              <Chart onRefresh={handleChartRefreshTeeRound}>
                <ChartLegend visible={false} />
                <ChartTitle
                  text={t("Rounds_by_Tee_Time")}
                  font="14pt sans-serif"
                />
                <ChartTooltip
                  border={{ color: "transparent" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedRoundsByTeeTimeTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" gap={1} />

                <ChartValueAxis>
                  <ChartValueAxisItem
                    min={0}
                    name="Rounds"
                    line={{ visible: false }}
                    labels={{ color: "black" }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    name="Rounds"
                    field="roundsValue"
                    categoryField="date"
                    axis="Rounds"
                    gap={1}
                    labels={{ color: "black" }}
                    color="green"
                    aggregate="avg"
                    type="column"
                    data={restrictedRoundsStartTime}
                  />
                </ChartSeries>
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    majorGridLines={{ visible: true, color: "#D4D4D4" }}
                    minorTicks={{ visible: false }}
                    labels={{
                      rotation: -90,
                      template: function (e) {
                        return moment(e.value).format("HH:mm");
                      },
                      padding: 0,
                      step: customStep,
                      position: "start",
                      margin: 0,
                    }}
                    categories={category2}
                    min={roundTeeMinDate}
                    max={moment(maxDate).add(60 / timeIncrement, "minutes")}
                    type="date"
                    baseUnit="seconds"
                    baseUnitStep={(60 / timeIncrement) * 60}
                  />
                </ChartCategoryAxis>
              </Chart>
            ) : (
              <>
                <strong>{t("Rounds_by_Tee_Time")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
        </ChartRow>
      </UsageContainer>
    </Wrapper>
  );
};

export default Reports;
